import { SpacerStyled } from './SpacerStyled';

type SpacerProps = {
  width?: number; // multiplier of theme.spacing
  height?: number; // multiplier of theme.spacing
};

export const Spacer = ({ width, height }: SpacerProps) => (
  <SpacerStyled data-testid="spacer" width={width} height={height} />
);
